export default __webpack_public_path__ + "static/media/Bracers of the Dragon King.502e80fc.jpg";